<script setup lang="ts">
import type { ReadonlyDeep } from 'type-fest';
import type { ARServiceItem, ARServiceItemList } from '@/models/airRoad';

import KCheckboxField from '@/components/fields/KCheckboxField.vue';
import NewAirRoadSpecialOptionDelTimeFieldset from '@/components/fieldsets/NewAirRoadSpecialOptionDelTimeFieldset.vue';
import NewAirRoadSpecialOptionDtRangeFieldset from '@/components/fieldsets/NewAirRoadSpecialOptionDtRangeFieldset.vue';
import NewAirRoadSpecialOptionPckReqFieldset from '@/components/fieldsets/NewAirRoadSpecialOptionPckReqFieldset.vue';
import NewAirRoadSpecialOptionPckUpTimeFieldset from '@/components/fieldsets/NewAirRoadSpecialOptionPckUpTimeFieldset.vue';
import NewAirRoadSpecialOptionSatSrvFieldset from '@/components/fieldsets/NewAirRoadSpecialOptionSatSrvFieldset.vue';
import NewAirRoadSpecialOptionUnpackFieldset from '@/components/fieldsets/NewAirRoadSpecialOptionUnpackFieldset.vue';

// TODO
/* eslint-disable @typescript-eslint/no-unnecessary-condition */

export interface Props {
  specialOptions?: ReadonlyDeep<ARServiceItemList>;
}
const props = withDefaults(defineProps<Props>(), {
  specialOptions: () => ({}),
});

const model = defineModel<Record<string, ARServiceItem>>({
  default: () => ({}),
});

function getIsDisabled(code: string): boolean {
  /* eslint-disable dot-notation, @typescript-eslint/dot-notation */
  if (
    code === 'AMSrv' &&
    (model.value['PMSrv']?.chosen ||
      model.value['DelTime']?.chosen ||
      model.value['PckUpTime']?.chosen)
  ) {
    return true;
  }
  if (
    code === 'PMSrv' &&
    (model.value['AMSrv']?.chosen ||
      model.value['DelTime']?.chosen ||
      model.value['PckUpTime']?.chosen)
  ) {
    return true;
  }
  if (
    code === 'DelTime' &&
    (model.value['AMSrv']?.chosen ||
      model.value['PMSrv']?.chosen ||
      model.value['PckUpTime']?.chosen)
  ) {
    return true;
  }
  if (
    code === 'PckUpTime' &&
    (model.value['AMSrv']?.chosen ||
      model.value['PMSrv']?.chosen ||
      model.value['DelTime']?.chosen)
  ) {
    return true;
  }
  return false;
  /* eslint-enable dot-notation, @typescript-eslint/dot-notation */
}
/* eslint-enable @typescript-eslint/no-unnecessary-condition */
</script>

<template>
  <ul
    :class="$style.newAirRoadSpecialOptionsBasicList"
    data-testid="newAirRoadSpecialOptionsBasicList"
  >
    <template
      v-for="(specialOption, index) in props.specialOptions"
      :key="specialOption.specialOptionId"
    >
      <li
        v-if="model[specialOption.code]"
        :class="$style.newAirRoadSpecialOptionsBasicListItem"
      >
        <fieldset :class="$style.primaryFieldset">
          <KCheckboxField
            v-model="model[specialOption.code].chosen"
            :label="specialOption.name"
            :class="$style.field"
            :disabled="getIsDisabled(specialOption.code)"
            hide-details
          />
          <template v-if="model[specialOption.code].chosen">
            <NewAirRoadSpecialOptionSatSrvFieldset
              v-if="specialOption.code === 'SatSrv'"
              v-model="model[specialOption.code]"
              :class="$style.secondaryFieldset"
            />
            <NewAirRoadSpecialOptionDelTimeFieldset
              v-if="specialOption.code === 'DelTime'"
              v-model="model[specialOption.code]"
              :class="$style.secondaryFieldset"
            />
            <NewAirRoadSpecialOptionUnpackFieldset
              v-if="specialOption.code === 'Unpack'"
              v-model="model[specialOption.code]"
              :class="$style.secondaryFieldset"
            />
            <NewAirRoadSpecialOptionDtRangeFieldset
              v-if="specialOption.code === 'DtRange'"
              v-model="model[specialOption.code]"
              :class="$style.secondaryFieldset"
            />
            <NewAirRoadSpecialOptionPckReqFieldset
              v-if="specialOption.code === 'PckReq'"
              v-model="model[specialOption.code]"
              :class="$style.secondaryFieldset"
            />
            <NewAirRoadSpecialOptionPckUpTimeFieldset
              v-if="specialOption.code === 'PckUpTime'"
              v-model="model[specialOption.code]"
              :class="$style.secondaryFieldset"
            />
          </template>
        </fieldset>
      </li>
      <li v-else :class="$style.newAirRoadSpecialOptionsBasicListItem">
        <fieldset :class="$style.primaryFieldset">
          <KCheckboxField
            disabled
            :label="specialOption.name"
            :class="$style.field"
            hide-details
          />
        </fieldset>
      </li>
    </template>
  </ul>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSpecialOptionsBasicList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-right: -24px;
}
  .newAirRoadSpecialOptionsBasicListItem {
    width: calc(20% - 24px);
  }
    .field {
    }
    .primaryFieldset {
      border: 0;
      padding: 0;
      margin: 0;
    }
      .secondaryFieldset {
        border: 0;
        padding: 0;
        margin: 0.5rem 0 0 0;
      }
</style>
